export const ECOMMERCE_DEVELOPMENT_ROOT = '/webapp/wcs/stores/servlet';
export const ECOMMERCE_DEVELOPMENT_PREVIEW_ROOT = '/webapp/wcs/preview/servlet';

export const SEARCH_ROUTE = '/SearchDisplay';
export const SHOP_ALL_CATEGORIES = '/ShopAllCategories';
export const PARTS_DIAGRAM = '/parts-diagram';

export const LEGACY_ACCOUNT_SECTION_ROUTE = '/AjaxLogonForm';
export const QUICK_ORDER =
  '/QuickOrderViewCmd?catalogId={0}&storeId={1}&langId={2}';
export const LEGACY_QUICK_ORDER_ITEM_DISPLAY_ROUTE =
  '/AjaxOrderItemDisplayView';
export const CART_ROUTE = '/cart';
export const QUICK_ORDER_ROUTE = `${CART_ROUTE}?openQuickOrder=true`;
export const SELF_SERVICE_OPTIONS =
  '/selfServiceOptions?storeId={0}&catalogId={1}&langId={2}&ssId={3}&isPM={4}&serialNumber={5}&salesModel={6}#maintenanceAndRepairs';
export const PMKIT_SERVICE_OPTIONS =
  '/selfServiceOptions?storeId={0}&catalogId={1}&langId={2}&ssId={3}&isPM={4}&serialNumber={5}&salesModel={6}&serialNoBegin={7}&serialNoEnd={8}&prefix={9}&unit={10}&isCATKit={11}#maintenanceAndRepairs';
export const SAVED_LIST_DETAIL_URL =
  '/AjaxLogonForm?catalogId={0}&langId={1}&storeId={2}&editable=true&createdBy={3}&requisitionListId={4}&requisitionListName={5}&route=RequisitionListDetailView';
export const LEGACY_SAVED_LISTS_URL =
  '/AjaxLogonForm?myAcctMain=1&route=RequisitionListdisplayView&catalogId={0}&langId={1}&storeId={2}';
export const CONTACT_DEALER_LINK = '/CATContactUsDisplayView';
export const ORDER_AND_QUOTE_CONFIRMATION_PAGE =
  '/OrderShippingBillingConfirmationView?shipmentTypeId=1&quoteOrderFlow=true&storeId={0}&catalogId={1}&langId={2}&orderId={3}&isQuoteOrder={4}';
export const LEGACY_PENDING_QUOTE_DETAIL_ROUTE =
  '/AjaxLogonForm?catalogId={0}&langId={1}&myAcctMain=1&route=PendingQuoteDetails&storeId={2}&orderId={3}';
export const LEGACY_PENDING_ORDER_DETAILS_ROUTE =
  '/AjaxLogonForm?orderId={0}&storeId={1}&langId={2}&catalogId={3}&route=PendingOrderDetails';
export const LEGACY_ORDER_DETAILS_ROUTE =
  '/AjaxLogonForm?fromOrderHistorySearchPage=false&storeId={0}&langId={1}&orderId={2}&dbsOrderId={3}&route=OrderDetail';
export const LEGACY_ORDER_STATUS_ROUTE =
  '/AjaxLogonForm?catalogId={0}&langId={1}&myAcctMain=1&orderId={2}&route=OrderStatus&storeId={3}&dbsOrderId={4}';
export const LEGACY_PICKING_UP_AND_DELIVERY_ROUTE = '/PickupAndDeliveryView';
export const LEGACY_SUMMARY_AND_PAYMENT_ROUTE =
  '/SingleShipmentOrderSummaryView';
export const RECENTLY_VIEWED_MODERNIZED_VIEW =
  '/SearchDisplay?catalogId={0}&langId={1}&storeId={2}&searchTerm={3}&searchType={4}';
export const SSRO_BUNDLE_PAGE =
  '/selfServiceOptions?storeId={0}&catalogId={1}&langId={2}&ssId={3}&isPM={4}&serialNumber={5}&salesModel={6}&unit={7}';
export const LEGACY_CAT_VANTAGE_REWARDS_URL =
  '/AjaxLogonForm?catalogId={0}&langId={1}&myAcctMain=1&route=CatVantageRewards&storeId={2}';

export const LEGACY_MY_ACCOUNT_PAGES = {
  PREFERENCES: 'ShoppingPreferences',
  EQUIPMENT: 'MyEquipment',
  ADDRESS_BOOK: 'AddressBook',
  LISTS: 'RequisitionListdisplayView',
  LIST_DETAILS: 'RequisitionListDetailView',
  PAYMENT: 'PaymentMethods',
  ORDERS: 'OrderHistory',
  ORDERS_TO_APPROVE: 'OrdersToApprove',
  ORDER_DETAILS: 'OrderDetail',
  ORDER_STATUS: 'OrderStatus',
  ORGANIZATIONS_AND_USERS: 'OrganizationsAndUsers',
  PENDINGQUOTES: 'PendingQuotes',
  PENDING_QUOTE_DETAILS: 'PendingQuoteDetails',
  PERSONAL_INFORMATION: 'PersonalInformation',
  CONTROL_CENTER: 'ControlCenter',
  ORGANIZATIONS_AND_USERS_DETAILS: 'OrganizationsAndUsersDetails',
  RETURN_FORM: 'OrderReturnRequest',
  MY_ACCOUNT_SUMMARY: 'MyAccountSummary',
  CORE_TRACKING: 'coreTracking',
  PENDING_ORDER_DETAILS: 'PendingOrderDetails',
  BLOCKS_LISTS: 'SavedListsBlocks',
  INVOICES: 'Invoices',
  INVOICE_DETAILS: 'InvoiceDetail',
  PENDING_QUOTES_BLOCKS: 'PendingQuotesBlocks',
  ORDERS_TO_APPROVE_BLOCKS: 'OrdersToApproveBlocks',
  CAT_VANTAGE_REWARDS: 'CatVantageRewards'
};

export const HEADLESS_MY_ACCOUNT_LINKS = {
  ADDRESS_BOOK: '/account/address-book',
  CONTROL_CENTER: '/account/control-center',
  CORE_TRACKING: '/account/core-tracking',
  ORDERS: '/account/orders',
  ORDER_HISTORY: '/account/orders/history',
  QUOTES: '/account/quotes?parentTab=myQuotes',
  INVOICES: '/account/invoices',
  SHOP_ALL_CATEGORIES: '/shop-all-categories',
  SHOPPING_PREFERENCES: '/account/shopping-preferences',
  NOTIFICATION_PREFERENCES: '/account/notification-preferences'
};

export const TERMS_LINKS = {
  CAT_TERMS_OF_USE: '/legal/legal-notices',
  CAT_LEGAL_TERMS_OF_USE: '/legal/legal-notices#legal',
  CAT_PRIVACY_NOTICE: '/legal/legal-notices#privacy',
  DEALER_TERMS: '/legal/terms-and-conditions',
  DEALER_PRIVACY_POLICY: '/legal/privacy-policy',
  CAT_PRIVACY_NOTICE_LINK: '/legal/privacy',
  CAT_LEGAL_TERMS_LINK: '/legal/legal-terms'
};

export const CSR_LEGACY_LANDING_PAGE_ROUTE = '/CustomerServiceLandingPageView';
export const CSR_HEADLESS_LANDING_PAGE_ROUTES = '/ccs-home';

export const CAT_HELP_CENTER_V2_URL = {
  BASE_URL: 'https://cat-crm.force.com',
  DEV_URL: 'https://catcrm--crmiuat.sandbox.my.site.com',
  BASE_ENDPOINT: 'HelpCenter/s',
  SUPPORT_ENDPOINT: 'HelpCenter/s/contactsupport',
  FAQ_ENDPOINT: 'HelpCenter/s/faqs'
};

export const LOGIN_REDIRECT_URL = '/account/login-redirect';
export const SIS_REDIRECT_URL = '/CATSISRedirect';
export const B2C_LOGIN_URL = '/b2c-login-punchout';
export const USER_REGISTRATION_FORM = '/UserRegistrationForm';

export const SHOPPING_CART = '/RESTOrderCalculate';
export const SHOPPING_CART_URL_PARAMETER = '/AjaxOrderItemDisplayView';
export const LOGOUT_URL = '/Logoff';
export const MY_EQUIPMENT_GUEST_URL = '/GuestUserMyEquipmentView';
export const CONTROL_CENTER_BLOCKS = '/account/control-center';
export const HEADLESS_ORDERS_TO_APPROVE = '/account/orders/to-approve';
export const PARTS_DIAGRAM_PATH = '/parts-diagram';
export const MAINTENANCE_REPAIRS_PATH = '/maintenance-and-repairs';
export const SHOP_PARTS_PATH = '/shop-parts';
export const MANUALS_AND_RESOURCES_PATH = '/manuals-and-resources';
export const ALP_URL = '/equipment';
export const PRODUCT_URL = '/product';

export const ORDER_INQUIRY = '/orders/inquiry/';

// Footer Links
export const ABOUT_CAT_PARTS = '/about';
export const SITE_MAP = '/site-map';

export const CAT_HELP_CENTER_OLD_URL = '/CATContactUsDisplayView';
export const CAT_FAQ_OLD_URL = '/help/faq';

export const WARRANTY_AND_RETURNS = '/warranty-and-returns';
export const ORDER_STATUS_INQUIRY = '/OrderStatusInquiry';

export const LEAVE_FEEDBACK_CONTROL_CENTER_START_PAGE =
  'https://caterpillar.co1.qualtrics.com/jfe/form/SV_eFjtLNwnkyYIkSy';
export const LEAVE_FEEDBACK_NO_CONTROL_CENTER_START_PAGE =
  'https://caterpillar.co1.qualtrics.com/jfe/form/SV_8B3sTWhXDAtL5VI';

export const HEADLESS_MY_EQUIPMENT_LINK = '/my-equipment';
export const HEADLESS_SESSION_EXPIRED = '/session-expired';

// acount links
export const HEADLESS_SAVED_LISTS = '/account/saved-lists';
export const HEADLESS_ADDRESS_BOOK = '/account/address-book';
export const HEADLESS_RECENTLY_VIEWED_PRODUCTS = '/recently-viewed-products';
export const HEADLESS_BUY_AGAIN_PRODUCTS = '/buy-again-products';
export const HEADLESS_CAT_VANTAGE_REWARDS = '/account/rewards';
export const HEADLESS_PAYMENT_METHODS = '/account/payment-methods';
export const HEADLESS_CONTROL_CENTER = '/account/control-center';
export const HEADLESS_SHOPPING_PREFERENCES = '/account/shopping-preferences';
export const HEADLESS_PERSONAL_INFORMATION = '/account/personal-information';

export const HEADLESS_CATEGORY_PAGE = '/category/:category';
export const HEADLESS_CATEGORY_PAGE_BASE_PATH = '/category';
export const HEADLESS_SEARCH_PAGE_MATCHER = '/search';
export const HEADLESS_SEARCH_PAGE = '/search?q={0}';
export const HEADLESS_PRODUCT_PAGE = '/product/:product';
export const HEADLESS_ALP_PAGE = '/equipment';
export const HEADLESS_PRODUCT_PAGE_PATH = '/product';
export const HEADLESS_PRODUCT_TECHNOLOGY_PAGE_PATH = '/technology';
export const HEADLESS_SSO_PAGE = '/equipment/{0}/{1}/self-service/{2}';
export const HEADLESS_PMKITS_PAGE =
  '/equipment/{0}/{1}/planned-maintenance/{2}';
export const HEADLESS_PICKUP_AND_DELIVERY_PAGE = '/pickup-and-delivery';
export const HEADLESS_PAYMENT_AND_SUMMARY_PAGE = '/payment-and-summary';
export const HEADLESS_HOME_PAGE = '/';
export const HEADLESS_PARTS_DIAGRAM_REDIRECTION_LINK = `/parts-diagram?systemId={0}&componentId={1}&ieSystemControlNumber={2}`;
export const HEADLESS_SHOP_BY_CATEGORY_PAGE = '/shop-all-categories';
export const SERVICE_RECOMMENDATION_LIST_PAGE = '/service-recommendations';
export const HEADLESS_ORDER_STATUS_PAGE = '/account/orders/{0}/status';
export const HEADLESS_ORDER_CONFIRMATION_PAGE = '/orders/{0}/confirmation';
export const HEADLESS_PAYMENT_POLICY = '/legal/payment-policy';
export const HEADLESS_SHIPPING_POLICY = '/legal/shipping-policy';

export const CONTACT_US_HEADLESS_ROUTE = '/contact-us';
